import RadioButton from 'shared/shared-component/components/RadioButton';
import visibilityHOC from 'hocs/visibility';
import forceFocus from 'hocs/forceFocus';

export default forceFocus(visibilityHOC(RadioButton));
